import { useContext } from 'react';
import { FlowScreen, ScreenAttributes, ScreenType } from 'core/flow/entities';
import { useFunnelData } from 'core/funnel/contexts';
import { QuizContext } from 'core/funnel/contexts/FlowContext';

const splitScreenTypes = new Set<ScreenType>([ScreenType.SPLIT, ScreenType.NEB_SPLIT]);

export const useNextScreensAttributes = (nextScreenId: string) => {
  const funnel = useFunnelData();
  const { getScreenAttributes } = useContext(QuizContext);

  const nextAttributes = getScreenAttributes(nextScreenId);

  if (!splitScreenTypes.has(nextAttributes.screenType)) {
    return [nextAttributes];
  }

  const nextScreensBySplit = funnel.flow?.screens?.find(
    (screen: FlowScreen) => screen.id === nextScreenId,
  );

  const nextAttributesBySplit = nextScreensBySplit?.attributes?.flatMap(
    (screen: { next: string }) => {
      const screenAttrs = getScreenAttributes(screen.next);

      return screenAttrs ? [screenAttrs] : [];
    },
  );

  return nextAttributesBySplit as ScreenAttributes[];
};
